export const SET_VOICE_ADD = "SET_VOICE_ADD";

export const setVoiceAdd = (patch) => ({
  type: SET_VOICE_ADD,
  payload: patch,
});

export const voiceAddInitialState = {
  open: false,
  phase: "idle",
  step: "chat",
  messages: [],
  drafts: [],
  results: [],
  prefill: null,
  busy: false,
  readyForReview: false,
  language: "English",
  scan: null,
  editingDraftId: null,
  sessionId: null,
  text: "",
};

const voiceAddReducer = (state = voiceAddInitialState, action) => {
  if (action.type !== SET_VOICE_ADD) return state;
  return { ...state, ...action.payload };
};

export default voiceAddReducer;
